import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  role: string;
  _id: string;
  phone: string;
  isActive: boolean;
}

const initialState: UserState = {
  role: "",
  _id: "",
  phone: "",
  isActive: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<UserState>) => {
      state.role = payload.role;
      state._id = payload._id;
      state.phone = payload.phone;
      state.isActive = payload.isActive;
    },
  },
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
